import { Link } from "react-router-dom";
import CustomNavBar from "../CustomNavBar";

const Header = () => {
  return (
    <>
    <CustomNavBar/>
    </>
  );
};
export default Header;

